<template>
    <div>Authorize</div>
</template>

<script>
    export default {
        name: "Authorize"
    }
</script>

<style scoped>

</style>